import {Directive, ElementRef, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validator} from "@angular/forms";

@Directive({
  selector: '[pagseguro][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: ValidadorPagamentoPagSeguroDirective, multi: true }
  ]
})
export class ValidadorPagamentoPagSeguroDirective  implements  Validator {
  @Input() pagseguro: any;

  constructor(private el: ElementRef) {
  }

  validate(c: AbstractControl): { [key: string]: any } {
    const pedido = this.pagseguro.pedido;
    const exigeCartao = this.pagseguro.exigeCartao;
    const dadosCartaoPedido = this.pagseguro.dadosCartao || pedido?.pagamento?.dadosCartao;
    const exigeEndereco = this.pagseguro.exigeEndereco;

    let erros: any = null;

    if( exigeCartao && !dadosCartaoPedido ) {
      erros = {dados_cartao_obrigatorio: 'dados_cartao_obrigatorio'};
    }
    else if( exigeCartao && pedido?.entrega?.formaDeEntrega ) {

      if(exigeEndereco && dadosCartaoPedido && !this.possuiEnderecoCobranca(pedido, dadosCartaoPedido)) {
        erros = {endereco_obrigatorio: 'endereco_obrigatorio'};
      }
    }

    return erros;
  }

  private possuiEnderecoCobranca(pedido: any, dadosCartaoPedido: any): boolean {
    return !!this.obtenhaEnderecoCobranca(pedido, dadosCartaoPedido)?.logradouro;
  }

  private obtenhaEnderecoCobranca(pedido: any, dadosCartaoPedido: any): any {
    if(dadosCartaoPedido?.endereco?.logradouro)
      return dadosCartaoPedido.endereco;

    if(pedido?.ehDelivery && pedido.ehDelivery())
      return pedido.endereco;

    const enderecosContato = pedido?.contato?.enderecos || [];
    const enderecoContato = enderecosContato.find((endereco: any) => endereco?.logradouro);

    return enderecoContato || pedido?.endereco;
  }
}
